export default "__VITE_ASSET__1bUnGgdL__"